<div class="copy-link-modal">
  @if (isLoading) {
    <div class="clm-loading">
      <div class="clm-spinner"></div>
      <span>Generating share link...</span>
    </div>
  } @else if (hasError) {
    <div class="clm-error">
      <app-icon name="alert-circle" [size]="20"></app-icon>
      <span>Failed to generate link.</span>
      <button class="clm-retry-btn" (click)="generateLink()">Retry</button>
    </div>
  } @else {
    <div class="clm-section">
      <label class="clm-label">Share Link</label>
      <div class="clm-copy-row">
        <input
          class="clm-input"
          type="text"
          [value]="link"
          readonly
        />
        <button class="clm-copy-btn" (click)="copyLink()" [class.copied]="linkCopied">
          <app-icon [name]="linkCopied ? 'check' : 'copy'" [size]="14"></app-icon>
          {{ linkCopied ? "Copied" : "Copy" }}
        </button>
      </div>
    </div>

    <div class="clm-section">
      <label class="clm-label">Access Code</label>
      <p class="clm-hint">Viewers will need this code to log in</p>
      <div class="clm-copy-row">
        <div class="clm-code">{{ accessCode }}</div>
        <button class="clm-copy-btn" (click)="copyCode()" [class.copied]="codeCopied">
          <app-icon [name]="codeCopied ? 'check' : 'copy'" [size]="14"></app-icon>
          {{ codeCopied ? "Copied" : "Copy" }}
        </button>
      </div>
    </div>
  }
</div>
